import { locale } from "../../locale";

function checkDateIsToday(d: Date) {
  const today = new Date();
  return (
    d.getDate() === today.getDate() &&
    d.getMonth() === today.getMonth() &&
    d.getFullYear() === today.getFullYear()
  );
}

export function getDateOrToday(d: Date) {
  if (checkDateIsToday(d)) return locale.chat.today;
  else
    return `${d.getDate()} ${locale.monthsOf[d.getMonth() as keyof typeof locale.monthsOf]} ${d.getFullYear()}`;
}
